"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRenderCellViews = useRenderCellViews;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@heroui/react");
var react_2 = require("@iconify/react");
var react_3 = require("react");
var toIconifyName_1 = require("../../../../../../helpers/icons/toIconifyName");
function CurrencyIconCell(_a) {
    var icon = _a.icon;
    if (icon === null || icon === void 0 ? void 0 : icon.url) {
        return (0, jsx_runtime_1.jsx)("img", { src: icon.url, alt: "", className: "h-10 w-10 rounded object-cover" });
    }
    if (icon === null || icon === void 0 ? void 0 : icon.name) {
        return (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: (0, toIconifyName_1.toIconifyName)(icon), width: 28, className: "text-foreground" });
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex h-10 w-10 items-center justify-center rounded border-2 border-dashed border-default bg-default", children: (0, jsx_runtime_1.jsx)(react_2.Icon, { icon: "solar:wad-of-money-linear", width: 18, className: "text-muted" }) }));
}
function useRenderCellViews() {
    // the shared table passes the value of the current cell, not the whole record, so each entry reads cellValue
    var renderCellViews = (0, react_3.useCallback)(function (cellValue) {
        var isReal = cellValue === "real";
        return [
            { key: "icon", content: (0, jsx_runtime_1.jsx)(CurrencyIconCell, { icon: cellValue }) },
            { key: "name", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm font-medium text-foreground", children: cellValue || "N/A" }) },
            { key: "code", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm uppercase text-muted", children: cellValue || "N/A" }) },
            {
                key: "type",
                content: cellValue ? ((0, jsx_runtime_1.jsx)(react_1.Chip, { size: "sm", variant: "soft", color: isReal ? "accent" : "default", children: isReal ? "Real" : "Virtual" })) : ((0, jsx_runtime_1.jsx)("span", { className: "text-sm text-muted", children: "N/A" })),
            },
            { key: "conversion_rate", content: (0, jsx_runtime_1.jsx)("div", { className: "text-nowrap text-sm text-muted", children: cellValue ? String(cellValue) : "N/A" }) },
        ];
    }, []);
    return { renderCellViews: renderCellViews };
}
